/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonVariant, Icon, Size } from "@blueprintjs/core"
import { ID } from "src/libs/interfaces/layouts"
import { PanelData } from "./interface"
import { __ } from "src/libs/utilities"

/* Protopia Ecosystem component */
export interface IPanelHeaderProps {
    title:string
    icon:string
    isOpen: boolean
    isTread: boolean
    addHeader?: JSX.Element
    setIsOpen: () => void
    onClose?: () => void
    activeData: PanelData
    setActiveId : ( panelDataId: ID ) => void 
    data: PanelData[]
}
const PanelHeader = ( props: IPanelHeaderProps ): JSX.Element => { 
    return <div className="pe-panel-header-container d-flex"> 
        {
            props.data.map(d => {
                return <SingleHeader 
                    key={d.id} 
                    {...d} 
                    isActive={d.id === props.activeData.id} 
                    setActiveId={() => props.setActiveId( d.id )}
                />
            })
        }
        <div className="mx-auto" />
        { props.addHeader }
        <Button size={Size.SMALL} variant={ButtonVariant.MINIMAL} onClick={props.setIsOpen}>
            <Icon icon={ props.isOpen ? "caret-up" : "caret-down" } size={ 11 } />
        </Button>
        {
            !!props.onClose && <Button size={Size.SMALL} variant={ButtonVariant.MINIMAL} onClick={ props.onClose }>
                <Icon icon="cross" size={ 11 } />
            </Button>
        }
    </div>
}

interface ISingleHeader {
    icon?: string
    title: string 
    isActive: boolean
    setActiveId: ()=> void
}
const SingleHeader = ( props: ISingleHeader ): JSX.Element => {
    return <div className={`btn-panel-header ${props.isActive ? "active" : "hint hint--top"}`} data-hint={ __(props.title) } onClick={  props.setActiveId }>
        {
            props.isActive && <Icon icon="drag-handle-vertical" size={10}  className="opacity_5 panel-drag" />
        }
        <img
            src={ props.icon }
            alt=""
            height={ 10 }
        />
        {
            props.isActive &&
            <div className="pe-panel-header-title text-overflow">
                { __(props.title) }
            </div>
        }
    </div>
}
export default PanelHeader